import React from 'react';

import moment from 'moment';

import RaisedButton from 'material-ui/RaisedButton';
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh';
import Toggle from 'material-ui/Toggle';

import OverallTable from './OverallTable';

import api from '../iCONSAPI'
import { timeout, nameSorter, companyNameMacSorter } from '../utils'

import './Overall.css';

class Overall extends React.Component {
  constructor(props) {
    super(props)

    this.autoRefreshDelay = 1500

    this.state = {
      autoRefreshEnable: false,
      autoRefreshTimer: 0,
      locationBody: [],
      beaconListBody: [],
      gatewayListBody: [],
    }
  }

  handleRefresh = (event) => {
    if (this.state.autoRefreshEnable) {
      this.handleAutoRefresh(null, false)
    }
    this.updateDisplay()
  }

  updateDisplay = () => {
    const requests = [
      timeout(api.timeout_ms, api.getBeacons()),
      timeout(api.timeout_ms, api.getGateways())
    ]

    Promise.all(requests)
      .then(responses => {
        responses.forEach(response => {
          if (!response.ok){
            throw response
          }
        })
        return Promise.all(responses.map(response => response.json()))
      }).then(jsons => {
        const beacons = jsons[0].data
        const gateways = jsons[1].data
        beacons.sort(companyNameMacSorter)
        gateways.sort(nameSorter)

        const gatewayMap = {};
        gateways.forEach(gateway => {
          gatewayMap[gateway.id] = gateway
        })

        this.setState({
          locationBody: beacons.filter(beacon => beacon.on_site)
            .map(beacon => ({
              columns: [
                beacon.name ? beacon.name : 'N/A',
                beacon.company ? beacon.company : 'N/A',
                gatewayMap[beacon.current_gateway_id].name
              ]
            })),
          beaconListBody: beacons.map(beacon => ({
            columns: [
              beacon.name ? beacon.name : 'N/A',
              beacon.company ? beacon.company : 'N/A',
              beacon.mac_address,
              beacon.on_site ? 'On Site' : (beacon.last_seen ?
                beacon.last_seen : 'Never')
            ]
          })),
          gatewayListBody: gateways.map(gateway => ({
            columns: [
              gateway.name,
              gateway.location ? gateway.location :
              'N/A',
              gateway.beacon_count ? gateway.beacon_count :
              '0',
              gateway.last_report ? gateway.last_report :
              'Never',
            ]
          }))
        })
      })
      // TODO: Logout if response.status === 403
      .catch(error => console.log(error))
  }

  handleAutoRefresh = (event, toggled) => {
    if (!toggled) {
      clearInterval(this.state.autoRefreshTimer)
    }
    this.setState({
      autoRefreshEnable: toggled,
      autoRefreshTimer: toggled ? setInterval(this.updateDisplay,
        this.autoRefreshDelay) : null
    })
  }

  render() {
    return (
      <div className="overall-container">
        <RaisedButton
          label="Refresh"
          labelPosition="after"
          primary={true}
          icon={<NavigationRefresh />}
          style={{marginTop: "1.5em", marginBottom: "1.5em"}}
          onTouchTap={this.handleRefresh}
        />
        <Toggle
          label="Automatic Refresh"
          labelPosition="right"
          toggled={this.state.autoRefreshEnable}
          style={{maxWidth: 250}}
          onToggle={this.handleAutoRefresh}
        />
        <p><em>Last refresh</em> @ {moment().format('YYYY-MM-DD HH:mm:ss')}</p>
        <OverallTable
          title="On Site"
          headers={["Name", "Company", "Gateway"]}
          body={this.state.locationBody}
        />
        <OverallTable
          title="Beacons"
          headers={["Name", "Company", "MAC Address", "Last Seen"]}
          body={this.state.beaconListBody}
        />
        <OverallTable
          title="Gateways"
          headers={["Name", "Location", "Beacon Count", "Last Report"]}
          body={this.state.gatewayListBody}
        />
      </div>
    )
  }
}

export default Overall;



// WEBPACK FOOTER //
// ./src/components/Overall.js